import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Shield, X } from 'lucide-react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
    window.location.reload();
  };

  const decline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] pointer-events-none" data-testid="cookie-consent-banner">
      <div className="max-w-3xl mx-auto bg-mlt-navy-dark border-[0.5px] border-white/10 rounded-xl p-5 sm:p-6 pointer-events-auto">
        <div className="flex items-start gap-4">
          <div className="shrink-0 mt-0.5">
            <div className="w-10 h-10 rounded-lg bg-mlt-orange/10 flex items-center justify-center">
              <Shield className="w-[18px] h-[18px] text-mlt-orange" strokeWidth={1.6} />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-white font-semibold text-base mb-1">We value your privacy</h3>
            <p className="text-sm text-white/50 leading-relaxed">
              We use cookies and similar technologies to improve your experience, analyse site traffic,
              and understand feature usage. This helps us build a better platform for you.
              Your data is stored securely and never shared with third parties.
            </p>
            <div className="flex flex-wrap gap-3 mt-4">
              <Button
                onClick={accept}
                className="bg-mlt-orange hover:bg-mlt-orange-hover text-white h-9 px-5 text-sm rounded-lg"
                data-testid="cookie-accept-btn"
              >
                Accept All
              </Button>
              <Button
                onClick={decline}
                variant="outline"
                className="border-white/20 text-white/70 hover:bg-white/10 h-9 px-5 text-sm rounded-lg"
                data-testid="cookie-decline-btn"
              >
                Decline
              </Button>
            </div>
          </div>
          <button onClick={decline} className="text-white/40 hover:text-white/70 shrink-0">
            <X className="w-[18px] h-[18px]" strokeWidth={1.6} />
          </button>
        </div>
      </div>
    </div>
  );
}
